import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ERPortServiceService {
  private baseUrl = new BehaviorSubject<string | null>(null);
  private minPort = 8005;
  private maxPort = 9000;

  constructor(private http: HttpClient) {
   //  this.discoverPort();
  }

  private discoverPort(port: number = this.minPort) {
    if (port > this.maxPort) {
      console.error('Unable to discover a working port');
      return;
    }

    this.http.get(`http://localhost:${port}/file-upload/health`, { responseType: 'text' })
      .pipe(
        map(() => `http://localhost:${port}`),
        catchError(() => of(null))
      )
      .subscribe(url => {
        if (url) {
          this.baseUrl.next(url);
        } else {
          this.discoverPort(port + 1);
        }
      });
  }

  getBaseUrl(): Observable<string> {
    return this.baseUrl.pipe(
      switchMap(url => {
        if (url) {
          return of(url);
        } else {
          return new Observable<string>(observer => {
            const subscription = this.baseUrl.subscribe(newUrl => {
              if (newUrl) {
                observer.next(newUrl);
                observer.complete();
              }
            });
            return () => subscription.unsubscribe();
          });
        }
      })
    );
  }
}
